import { useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Check, Eye } from "lucide-react";
import { toast } from "sonner";

export default function FileUpload({ label, value, onChange, accept = "image/*,application/pdf", testid }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const token = localStorage.getItem("wl_token");
  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path, data.filename);
      toast.success(`${label} uploaded`);
    } catch {
      toast.error("Upload failed — please try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-slate-700">{label}</label>
      <div className="flex items-center gap-3">
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={upload} data-testid={testid} />
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()}>
          {busy ? "Uploading…" : value ? <><Check className="mr-1.5 h-4 w-4 text-green-600" /> Replace</> : <><Upload className="mr-1.5 h-4 w-4" /> Upload</>}
        </Button>
        {value && <a href={`${BACKEND}/api/files/${value}?auth=${token}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-medium text-brand hover:underline"><Eye className="h-4 w-4" /> View</a>}
      </div>
    </div>
  );
}
